import ReportLayout from 'src/pages/Reports/Common/report/ReportLayout';
import ReportDetails from 'src/pages/Reports/Common/report/ReportDetails';

const ClerkVending = () => (
  <ReportLayout title="Clerk Amusement/Vending Licenses Report">
    <ReportDetails
      title="Report Details"
      downloadEndpoint="clerk_vending/download"
    />
  </ReportLayout>
);

export default ClerkVending;
